module.exports = __webpack_public_path__ + "static/media/option7.7202591f.png";